
import envConfig from '../../utils/envConfig'

import { getMainDefinition } from '@apollo/client/utilities';
import { split } from '@apollo/client';
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from 'graphql-ws';
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { ChosenBackend } from './backend'
import { ApolloLink } from '@apollo/client';

// we can only move to 
// https://www.apollographql.com/docs/react/api/link/apollo-link-subscriptions
// after upgrading hasura to > 2.1

// Declare locations
const backend = ChosenBackend()
const graphql_us = envConfig[process.env.REACT_APP_ENVIRONMENT]['graphql_us_uri']
const graphql_eu = envConfig[process.env.REACT_APP_ENVIRONMENT]['graphql_eu_uri']

export let websocket_connected = false;

// Create WSS URL
const wsLink = new GraphQLWsLink(
  createClient({
    url: "wss://" + backend,
    on: {
      connected: () => websocket_connected = true,
    },
    options: {
      reconnect: true, timeout: 20000, lazy: true,
      connectionParams: {
        headers: {
        }
      }
    }
  }),
);

const wsLinkUS = new GraphQLWsLink(
  createClient({
    url: "wss://" + graphql_us,
    on: {
      connected: () => websocket_connected = true,
    },
    options: {
      shouldRetry: true, timeout: 20000, lazy: true,
      connectionParams: {
        headers: {
        }
      }
    }
  }),
);

const wsLinkEU = new GraphQLWsLink(
  createClient({
    url: "wss://" + graphql_eu,
    on: {
      connected: () => websocket_connected = true,
    },
    options: {
      reconnect: true, timeout: 20000, lazy: true,
      connectionParams: {
        headers: {
        }
      }
    }
  }),
);

const headers = {
  "x-hasura-application": "controlcenter-ui",
}

// Create HTTP URL
const httpLink = new BatchHttpLink({
  uri: "https://" + backend,
  batchMax: 5,
  batchInterval: 20,
  headers: headers
})

const httpLinkUS = new BatchHttpLink({
  uri: "https://" + graphql_us,
  batchMax: 5,
  batchInterval: 20,
  headers: headers
})

const httpLinkEU = new BatchHttpLink({
  uri: "https://" + graphql_eu,
  batchMax: 5,
  batchInterval: 20,
  headers: headers
})

// Default V2 Endpoints are RR so when writing we need to remove readonly

const httpLinkUSWrite = new BatchHttpLink({
  uri: "https://" + graphql_us.replace("-readonly", ""),
  batchMax: 5,
  batchInterval: 20,
  headers: headers
})

const httpLinkEUWrite = new BatchHttpLink({
  uri: "https://" + graphql_eu.replace("-readonly", ""),
  batchMax: 5,
  batchInterval: 20,
  headers: headers
})

// Detect and split based on operation type for mutations

const splitUSMutation = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'mutation'
    );
  },
  httpLinkUSWrite,
  httpLinkUS,
)

const splitEUMutation = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'mutation'
    );
  },
  httpLinkEUWrite,
  httpLinkEU,
)

const linkWssHttpDefault = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
)

// if using v2 then use the US/EU links accordingly to the context backend setting
// if not using v2 then use the default gql endpoint always

const linkWssHttpContext = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  split(
    (operation) => {
      return (
        operation.getContext().backend === 'us'
      );
    }, wsLinkUS, wsLinkEU
  ),
  split(
    (operation) => {
      return (
        operation.getContext().backend === 'us'
      );
    }, splitUSMutation, splitEUMutation
  ),
)

const link = ApolloLink.split(
  operation => operation.getContext().backend,
  linkWssHttpContext,
  linkWssHttpDefault,
);

export default link